import useSWR from 'swr';
import type { PropertyBuildingOption } from '../models/PropertyBuildingOption';
import type { SwrReturnType } from '~/models/Api';

const paths = {
  index: '/property_building_options'
} as const;

type TIndex = (name: string) => SwrReturnType<PropertyBuildingOption[]>;

type ReturnType = {
  index: TIndex;
};

export const usePropertyBuildingOptions = (): ReturnType => {
  const index: TIndex = (name: string) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error, isValidating } = useSWR(
      name.length >= 2 ? { url: paths.index, params: { name } } : null
    );
    return {
      data: data ?? null,
      mutate: mutate ?? null,
      isLoading: !data && !error,
      isValidating,
      error
    };
  };
  return { index };
};
